import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/* eslint-disable react/prop-types */

const HeroCarousel = ({ events }) => {
    const slides = events.map((event) => {
        const eventUrl = event.eventUrl || `/eventos/${event.slug}`;

        return {
            id: event.uniqueId || event.id,
            img: event.img,
            nombre: event.nombre,
            eventUrl,
            isExternalEvent: /^https?:\/\//.test(eventUrl),
        };
    });
    // Centered slides need five items for Swiper's circular mode at these breakpoints.
    const canLoop = slides.length >= 5;

    return (
        <Swiper
            key={canLoop ? "loop" : "rewind"}
            modules={[Navigation, Pagination, Autoplay]}
            navigation
            pagination={{ clickable: true }}
            autoplay={{
                delay: 3000,
                disableOnInteraction: false,
            }}
            centeredSlides
            grabCursor
            slideToClickedSlide
            breakpoints={{
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 2,
                },
                480: {
                    slidesPerView: 1.5,
                    spaceBetween: 0,
                },
                640: {
                    slidesPerView: 1.7,
                    spaceBetween: 0,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
            }}
            loop={canLoop}
            rewind={!canLoop}
            className="hero-swiper h-[78vh] min-h-[460px] w-full overflow-hidden [--swiper-navigation-color:rgb(34_197_94)] [--swiper-pagination-color:rgb(37_99_235)] [--swiper-pagination-bullet-inactive-color:rgb(161_161_170)] [--swiper-navigation-size:30px]"
        >
            {slides.map((slide, index) => (
                <SwiperSlide
                    key={slide.id}
                    className="hero-slide !h-full"
                >
                    <HeroSlide
                        slide={slide}
                        isPriority={index === 0}
                    />
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

const HeroSlide = ({ slide, isPriority }) => {
    const image = (
        <img
            src={slide.img}
            alt={slide.nombre || "Evento"}
            width="600"
            height="750"
            loading={isPriority ? "eager" : "lazy"}
            fetchPriority={isPriority ? "high" : "auto"}
            decoding="async"
            className="hero-slide-image"
        />
    );

    if (slide.isExternalEvent) {
        return (
            <a
                href={slide.eventUrl}
                className="hero-slide-link group"
            >
                {image}
            </a>
        );
    }

    return (
        <Link
            to={slide.eventUrl}
            className="hero-slide-link group"
        >
            {image}
        </Link>
    );
};

export default HeroCarousel;
